import React, {ReactElement} from "react";
import style from "./style.less";
import Typography from "../Typography";
import {TypographySizes, TypographyTypes} from "../Typography/Typography";
import {ProgressReportResponse} from "../../services/api/elearningapi";
import Divider from "../Divider";
import {FormattedMessage} from "react-intl";
import ElearningProgressRow from "./ElearningProgressRow";

interface ElearningProgressProps {
  progress: ProgressReportResponse
  /** When false, no divider above the section (e.g. theory is first on the page). Default false. */
  showLeadingDivider?: boolean
  /** Lighter container without elevation shadow (overview layout). */
  flat?: boolean
}

const ElearningProgress: React.FunctionComponent<ElearningProgressProps> = ({
  progress,
  showLeadingDivider = false,
  flat = false,
}): ReactElement => {
  return (
    <div>
      {showLeadingDivider ? <Divider small={true} /> : null}
      <Typography type={TypographyTypes.headline} size={TypographySizes.small}>
        <FormattedMessage id={'theory_progress'} />
      </Typography>

      <div className={flat ? style.theorySectionFlat : style.smallBox}>
        {progress.report.entries.map((entry, index) => (
          <React.Fragment key={entry.name}>
            <ElearningProgressRow
              title={entry.name}
              progress={entry}
            />
            <Divider small={true} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default ElearningProgress
